var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M13 13L31 31","strokeWidth":"4","key":1}),React.createElement("path",{"d":"M31 13L13 31","strokeWidth":"4","key":2})]);
}

IconClose.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = IconClose;

IconClose.default = IconClose;
